@if (isAccountPolicyLayoutEnabled) {
  <app-sidebar-layout [menuItems]="menuItems" [activeItemId]="activeItemId" (itemSelected)="onItemSelected($event)">
  </app-sidebar-layout>
} @else {
  <app-policies></app-policies>
}
